import React, { useState, useEffect } from "react";
import { useNavigate, useNavigation } from "react-router-dom";
import Swal from "sweetalert2";
import request from "../../Apis/request";
import { BaseURL, uniqueToken } from "../../api/DataApis";
import axios from "axios";


function Add() {
  document.title = "Station | Add";
  let navigate = useNavigate();
  const [TitleName, setTitleName] = useState([]);
  const [selectedStatusType, setSelectedStatusType] = useState("");
  const [LatitudePoints, setLatitudePoints] = useState([]);
  const [LongitudePoints, setLongitudePoints] = useState([]);
  const [Address, setAddress] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [vendorData, setVendorData] = useState([]);
  const [selectedvendor, setselectedvendor] = useState('');
  const [VendorAmount, setVendorAmount] = useState('');
  const [offers, setOffers] = useState([]);
  const [selectedOffer, setselectedOffer] = useState('');





  const handleTitleName = (e) => {
    setTitleName(e.target.value);
  };
  const handlevendorAmount = (e) => {
    setVendorAmount(e.target.value);
  }
  const handleOfferChange = (e) => {
    setselectedOffer(e.target.value);
  }

  const handleVendorName = (e) => {
    setselectedvendor(e.target.value);
  };

 

  const handleFileChange = (event) => {
    const filesArray = Array.from(event.target.files).map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file), // Create a preview URL for each file
      })
    );
    setSelectedFiles((prevFiles) => [...prevFiles, ...filesArray]);
    // event.target.value = null; // Reset the input value
  };
  


  
  
  const handleAddresshandle = (e) => {
    setAddress(e.target.value);
  };

  const handleLongitudeName = (e) => {
    setLongitudePoints(e.target.value);
  };
  const handleLatitudeName = (e) => {
    setLatitudePoints(e.target.value);
  };


  const handleStatusType = (e) => {
    setSelectedStatusType(e.target.value);
  };


  useEffect(() => {
    // Fetch countries on component mount
    const fetchOffersListing = async () => {
      try {
        const response = await axios.get(`${BaseURL}/offer`, {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        setOffers(response.data.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchOffersListing();
  }, []);

  useEffect(() => {
    // Fetch countries on component mount
    const fetchVendorListing = async () => {
      try {
        const response = await axios.get(`${BaseURL}/user/get-all?userType=Vendor`, {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        setVendorData(response.data.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchVendorListing();
  }, []);

  const AddStation = async () => {
    // Show loader before API call
    Swal.fire({
      title: 'Adding Charger...',
      text: 'Please wait',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    const data = [
      {
        "service_provider_id": selectedvendor,
        "percentage": VendorAmount
      }
    ];
  
    // Create a new FormData object
    let formData = new FormData();
    formData.append("station_name", TitleName);
    formData.append("address", Address);
    formData.append("latitude", LatitudePoints);
    formData.append("longitude", LongitudePoints);
    if(selectedOffer) {
      formData.append("offer_id", selectedOffer);
    }
    if (selectedvendor) {
      data.forEach((item, index) => {
        formData.append(`service_provider[${index}][service_provider_id]`, item.service_provider_id);
        formData.append(`service_provider[${index}][percentage]`, item.percentage);
      });
    }
     
    
    // formData.append("status", selectedStatusType);  
  
    if (selectedFiles && selectedFiles.length > 0) {
      // Loop over selected files and append each one to the FormData
      for (let i = 0; i < selectedFiles.length; i++) {
        formData.append("station_image", selectedFiles[i]); // Append each file
      }
    }
    
  
    try {
      // Make the API request
      let response = await axios.post(
        `${BaseURL}/station/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
            // 'Content-Type' is automatically set by axios when using FormData
          },
        }
      );
  
      // Hide the loader
      Swal.close();
  
      // Handle the response
      if (response.data.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: response?.data?.message,
          showConfirmButton: false,
          timer: 1500,
        });
        navigate(`/stations`);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `Failed to update station. Status: ${response.data.statusCode}`,
        });
      }
    } catch (error) {
      // Hide the loader
      Swal.close();
  
      console.error("Error in AddCharger:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "An unexpected error occurred.",
      });
    }
  };
  // console.log("uniquetoken", uniqueToken);
console.log("vendorData", vendorData);
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <h1 className="page-title"></h1>
              <div className="portlet light bordered">
                <div className="portlet-title row">
                  <div className="caption font-dark col-md-10">
                    <h4 className="caption-subject bold uppercase mx-3">
                      Station Add
                    </h4>
                  </div>
                  <div className="caption font-dark col-md-2">
                    <h5 className="caption-subject bold uppercase mx-3">
                      <button className="btn btn-success" onClick={() => navigate(-1)}>
                        Back
                      </button>
                    </h5>
                  </div>
                </div>
                <div className="portlet-body mx-3">
                  <hr />
                  <div className="row">
                    <div className="col-sm-12">
                      <form
                        className="form-horizontal"
                        encType="multipart/form-data"
                        role="form"
                        method="post"
                        style={{ marginTop: "-20px" }}
                      >
                        <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="name_id"
                              className="col-sm-2 control-label"
                            >
                              Station Name
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleTitleName}
                                className="form-control"
                                id="name_id"
                                name="name"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="name_id"
                              className="col-sm-2 control-label"
                            >
                              Latitude
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleLatitudeName}
                                className="form-control"
                                id="name_id"
                                name="name"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="name_id"
                              className="col-sm-2 control-label"
                            >
                              Longitude
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleLongitudeName}
                                className="form-control"
                                id="name_id"
                                name="name"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="name_id"
                              className="col-sm-2 control-label"
                            >
                              Address
                            </label>
                            <div className="col-sm-6">
                              <textarea
                                onChange={handleAddresshandle}
                                className="form-control"
                                id="name_id"
                                name="name"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="name_id"
                              className="col-sm-2 control-label"
                            >
                              Service Provider
                            </label>
                            <div className="col-sm-6">
                              <select
                                onChange={handleVendorName}
                                className="form-control"
                                id="name_id"
                                name="name"
                              >
                                <option value="0">Select Vendor</option>
                                {vendorData?.map((item) => {
                                  return (
                                    <option
                                      key={item?._id}
                                      value={item?._id}
                                    >
                                      {item?.name}
                                    </option>
                                  );
                                })}
                                </select>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        {
selectedvendor  &&  
  <>
  <div className="form-group">
  <div className="row">
    <label htmlFor="statusType" className="col-sm-2 control-label">
    Vendor Percentage
    </label>
    <div className="col-sm-6">
      <input
        onChange={handlevendorAmount}
        value={VendorAmount}
        type="number"
        className="form-control"
        id="statusType"
        name="statusType"
      />
   
  
    </div>
    <span className="col-sm-4 control-label"></span>
  </div>
</div>
</>
}
<div className="form-group">
  <div className="row">
    <label htmlFor="name_id" className="col-sm-2 control-label">Offer</label>
    <div className="col-sm-6">
      <select 
        type="file"
        onChange={handleOfferChange}
        className="form-control"
        id="name_id"
        name="name"
         // Enable multiple file selection
      >
          <option value="0">Select Offer </option>
                                {offers?.map((item) => {
                                  return (
                                    <option
                                      key={item?._id}
                                      value={item?._id}
                                    >
                                      {item?.title}
                                    </option>
                                        );
                                })}

        </select>
            <div>
      
      </div>
    </div>
    <span className="col-sm-4 control-label"></span>
  </div>
</div>
                  
                        <div className="form-group">
  <div className="row">
    <label htmlFor="name_id" className="col-sm-2 control-label">Image</label>
    <div className="col-sm-6">
      <input 
        type="file"
        onChange={handleFileChange}
        className="form-control"
        id="name_id"
        name="name"
        multiple // Enable multiple file selection
      />
            <div>
        {selectedFiles.length > 0 && (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
            {selectedFiles.map((file, index) => (
              <div key={index}>
                <img
                  src={file.preview} // Use the preview URL for the image
                  alt={`preview-${index}`}
                  style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
    <span className="col-sm-4 control-label"></span>
  </div>
</div>

                       
                        <div className="form-group">
                          <div className="col-sm-offset-2 col-sm-8 add-class">
                            <input
                              type="button"
                              className="btn btn-success"
                              onClick={AddStation}
                              value="Add Station"
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Add;
